module.exports = __webpack_public_path__ + "static/Maruthi-Ritz-689d5b65ec1e0cac958aa7f99d48b8af.png";